export default __webpack_public_path__ + "static/media/FacilityViewPopIcon.56175b19.svg";